<template>
	<el-dialog title="同步星选样品协作" :visible.sync="visible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
		<div class="yx-color-text-primary font-h4-regular">
			共选中
			<span class="color-p-4">{{ total }}</span>
			个样单，
			<span class="color-g-4">{{ type === 'rd' ? partnerList.length : merchantList.length }}</span>
			个符合协作条件，
			<span class="color-r-4">{{ type === 'rd' ? merchantList.length : partnerList.length }}</span>
			个不符合协作条件，继续将仅操作符合协作条件样单，是否确认？
		</div>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button @click="confirm" type="primary">确定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { batchSyncCooperate, batchSyncPartnerCooperate } from '@/api/sampleOrder';
export default {
	name: 'syncCollaborate',
	computed: {
		total({ list }) {
			return list.length;
		},
		partnerList({ list }) {
			// 星选
			return list.filter(item => item.cooperate_partner_info?.audit_role === 'rd') || [];
		},
		merchantList({ list }) {
			// 商家
			return list.filter(item => item.cooperate_partner_info?.audit_role !== 'rd') || [];
		},
	},
	data() {
		return {
			visible: false,
			list: [],
			type: '', // 1: type = 空 => 商团协作 2: type = rd => 星选协作
		};
	},
	methods: {
		show(list = [], type) {
			this.list = list;
			this.type = type;
			this.visible = true;
		},
		async confirm() {
			const { partnerList, merchantList, type } = this;
			let res;
			if (type === 'rd') {
				const sampleSnList = partnerList.map(item => item.sample_sn);
				res = await batchSyncPartnerCooperate({ sampleSnList });
			} else {
				const sample_sn_list = merchantList.map(item => item.sample_sn);
				res = await batchSyncCooperate({ sample_sn_list });
			}

			if (res?.fail?.length) {
				this.$modal({
					title: '提示',
					contentTitle: `共有 ${res.fail.length} 条同步失败，无法发送协作申请原因详见单个样品订单`,
					size: 'small',
					btns: [
						{
							type: 'primary',
							text: '我知道了',
							key: 'confirm',
						},
					],
				}).then(res => {
					if (res.key == 'confirm') {
						res.done();
					} else {
						res.done();
					}
				});
			} else {
				this.$message.success('操作成功！');
			}
			this.$emit('refresh');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
		},
	},
};
</script>

<style lang="less" scoped></style>
